export default __webpack_public_path__ + "static/media/projectfour.511e6b9a.jpg";